import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Icon from '@material-ui/core/Icon';
import Button from '~/components/Button';

import useStyles from './styles';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})(props => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

function PaperButtons({ openDropDown, setOpenDropDown, setModalCategory, setModalFolder, setModalArticle}) {
  const { t } = useTranslation();
  const classes = useStyles();

  function handleEditFirst(){
    setModalCategory(true);
    setOpenDropDown(null);
  }

  function handleEditSecond(){
    setModalFolder(true);
    setOpenDropDown(null);
  }

  function handleEditThird(){
    setModalArticle(true);
    setOpenDropDown(null);
  }

  function handleClick(event) {
    setOpenDropDown(event.currentTarget);
  }

  return (
    <div className={classes.root}>
      <Button className={classes.button} color='success' onClick={handleClick} >{t('button-menu-new')}
        <Icon>arrow_drop_down</Icon>
      </Button>
      <StyledMenu
        id='actions-menu'
        keepMounted
        anchorEl={openDropDown}
        open={Boolean(openDropDown)}
        onClose={() => setOpenDropDown(null)}
      >
        <MenuItem onClick={() => handleEditFirst()} >
          {t('faq.extras.category_new')}
        </MenuItem>
        <MenuItem onClick={() => handleEditSecond()} >
          {t('faq.extras.folder_new')}
        </MenuItem>
        <MenuItem onClick={() => handleEditThird()}>
          {t('faq.extras.article_new')}
        </MenuItem>
      </StyledMenu>
    </div>
  );
}

PaperButtons.propTypes={
  openDropDown: PropTypes.object,
  setOpenDropDown: PropTypes.func.isRequired,
  setModalCategory: PropTypes.func.isRequired,
  setModalFolder: PropTypes.func.isRequired,
  setModalArticle: PropTypes.func.isRequired,
};
export default withRouter(PaperButtons);
